import { debounce } from '../../utils';
class MovingBorder {
    constructor(container) {
        this.container = container;
        this.svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        this.svgRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");

        this.svgRect.setAttribute("x", "2");
        this.svgRect.setAttribute("y", "2");
        this.svgRect.setAttribute("fill", "none");
        this.svgRect.setAttribute("stroke", "#93CA15");
        this.svgRect.setAttribute("stroke-miterlimit", "20");

        this.svgElement.appendChild(this.svgRect);
        this.container.appendChild(this.svgElement);
        this.resizeSVG = this.resizeSVG.bind(this);
        this.resizeSVG();
        window.addEventListener("resize", debounce(this.resizeSVG, 100));
        const resizeObserver = new ResizeObserver(debounce(this.resizeSVG, 100));
        resizeObserver.observe(this.container);
    }

    resizeSVG() {
        let rect = this.container.getBoundingClientRect();
        const width = Math.round(rect.width) + 6;
        const height = Math.round(rect.height) + 6;
        this.svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
        this.svgRect.setAttribute("width", `${width - 4}`); // -4 to account for the stroke width
        this.svgRect.setAttribute("height", `${height - 4}`); // -4 to account for the stroke width

        let perimeter = 2 * (width + height) + 16;
        this.svgRect.style.strokeDasharray = `16 ${perimeter}`;
        this.svgRect.style.strokeDashoffset = perimeter;

        let speed = 150; // Adjust this to control the speed of the animation.
        let animationDuration = perimeter / speed;
        this.svgRect.style.animation = `spinMovingBorder ${animationDuration}s infinite linear`;
    }
}

export default MovingBorder;
